var _excluded = ["tag", "ssi"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
import PropTypes from "prop-types";
import PageletContainer from "@xo-union/react-pagelet";
import { getFooterAssetUrl, getFooterSSIUrl } from "../../utils/urls.js";
import Placeholder from "./Placeholder/index.js";
var handleError = function handleError(evt) {
  if (evt.detail.isRendered && evt.detail.phase === 'load' && process.env.NODE_ENV === 'production') {
    /**
     * If footer nav is already rendered, do not show error view
     */
    evt.preventDefault();
  }
};

/**
 * Renders a footer nav pagelet which gets dynamically updated as changes to the footer are made.
 *
 * Basides it's own props, this component also accepts all props accepted by the FootereNav component
 */
var FooterNavPagelet = function FooterNavPagelet(_ref) {
  var tag = _ref.tag,
    ssi = _ref.ssi,
    rest = _objectWithoutProperties(_ref, _excluded);
  var links = {
    ssi: getFooterSSIUrl(tag, 'index.html'),
    css: getFooterAssetUrl(tag, 'styles.css'),
    js: getFooterAssetUrl(tag, 'main.js')
  };
  return /*#__PURE__*/React.createElement(PageletContainer, {
    onError: handleError,
    renderPlaceholder: Placeholder,
    containerId: "footer-navigation",
    links: links,
    ssi: ssi,
    pageletProps: rest
  });
};
process.env.NODE_ENV !== "production" ? FooterNavPagelet.propTypes = {
  /**
   * Pagelet tag to use. Primary tag will always be `latest` but in cases where we need
   * to maintain support for an older version of the footer pagelet, we will support other tags.
   *
   * The tag can also be a fixed footer pagelet version
   */
  tag: PropTypes.string,
  /**
   * Whether or not to enable SSI. This is recommended to improve rendering performance as this accomplishes
   * server side rendering. NOTE: This requires that the backend server that serves the HTML
   * for the current page to support `ssi` directives.
   */
  ssi: PropTypes.bool
} : void 0;
FooterNavPagelet.defaultProps = {
  tag: 'latest',
  ssi: false
};
export default FooterNavPagelet;